import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import AppleIso from "@crehana/icons/logos/AppleIso";
import GooglePlayIso from "@crehana/icons/logos/GooglePlayIso";
import { Col, PrimaryButton } from "@crehana/ui";
import { css } from "styled-components";
const AppsColumn = ({ isDark, className })=>{
    const { t } = useTranslation('main-footer');
    return /*#__PURE__*/ jsxs(Col, {
        sm: 4,
        md: 2,
        offset: {
            sm: 1,
            md: 0
        },
        nowrap: true,
        className: className,
        children: [
            /*#__PURE__*/ jsx("p", {
                className: `font-button mb-20 ${isDark ? 'text-base-lighter' : 'text-base-dark'}`,
                children: t('FOOTER_DOWNLOAD', 'Descarga nuestra app')
            }),
            /*#__PURE__*/ jsxs("div", {
                css: css`
          ${(props)=>props.theme.breakpoints.up('sm')} {
            width: 172px;
          }
        `,
                children: [
                    /*#__PURE__*/ jsx(PrimaryButton, {
                        label: "Google play",
                        href: "https://play.google.com/store/apps/details?id=com.crehana.android",
                        leftIcon: {
                            component: GooglePlayIso,
                            size: 18
                        },
                        className: `w-full mb-8 ${isDark ? 'bg-gray-main-dark-mode' : 'bg-base-dark'}`
                    }),
                    /*#__PURE__*/ jsx(PrimaryButton, {
                        label: "App Store",
                        href: "https://itunes.apple.com/us/app/crehana/id1353031284",
                        leftIcon: {
                            component: AppleIso,
                            size: 18
                        },
                        className: `w-full ${isDark ? 'bg-gray-main-dark-mode' : 'bg-base-dark'}`
                    })
                ]
            })
        ]
    });
};
const components_AppsColumn = AppsColumn;
export default components_AppsColumn;
